module.exports = __webpack_public_path__ + "img/layout.c1ed4019.svg";